import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import UI from "../../../../components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import UIUtils from "../../../../utils/UIUtils";
import UISunEditor from "../../../../components/wysiwygeditor/UISunEditor";
function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [loadFinish,setLoadFinish] = useState(false);

	const [modiSeq ,setModiSeq] = useState('');
	const [donReqDivCd ,setDonReqDivCd] = useState('');

	const [title,setTitle] = useState('');
	const [cont,setCont] = useState('');
	const [bizNm,setBizNm] = useState('');
	const [regDate,setRegDate] = useState('');
	const [regUserNm,setRegUserNm] = useState('');
	const serverUrl = 'http://dev.fund.win-win.or.kr/';

	//파일정보 선언
	const [fileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());

	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");

	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	    console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
				}

				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})
		setFileInfoList(fileInfos);

    }

	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	async function deleteAnn(){
		if(await UIUtils.confirm('삭제하시겠습니까?')){
			let param = {
				"MODI_SEQ": modiSeq
			};

			const response:any = await CommonUtil.execute({
				url:'adm_1201_delete',
				data: param
			}).then((response: any) => {				
				UIUtils.alert('삭제되었습니다.').then();
				const result = response;

			
				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './adm1200',
					state: { data: {} }
				});
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});

			
		}




	};



	async function initCall(){

		let param = {
			"MODI_SEQ": receivedData.vMODI_SEQ,
			"DON_REQ_DIV_CD": receivedData.vDON_REQ_DIV_CD
		};



		const response:any = await CommonUtil.execute({
			url:'adm_1201',
			data: param
		})

		const result = response;


		//setCorpInfo(result);

		console.log(result)
		setBizNm(result.BIZ_NM);
		setRegDate(result.REG_DATE);
		setRegUserNm(result.REG_USERNM);
		setTitle(result.DON_ANN_TITLE);
		setCont(result.DON_ANN_CONT);
		

		/*if(result.FILE_INFO != null){
            let fileInfo = result.FILE_INFO;
			//파일등록 정보
			fileInfo?.forEach((fileInfo, index) => {
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(fileInfo.DWLD_ID);
				fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
				fileDetail.setStrePath(fileInfo.STRE_PATH);
				fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
				fileDetail.setFileSize(fileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(fileInfo.REGIST_DT);

				fileValue.putTbComFileMapngDetailList(fileDetail);
			})			
		}*/

		if(result.FILE_INFO != null){
            let fileInfo = result.FILE_INFO;
			//파일등록 정보

			const fileDetail = new TbComFileMapngDetail();
			fileDetail.setDwldId(fileInfo.DWLD_ID);
			fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
			fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
			fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
			fileDetail.setStrePath(fileInfo.STRE_PATH);
			fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
			fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
			fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
			fileDetail.setFileSize(fileInfo.FILE_SIZE);
			fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
			fileDetail.setRegistDt(fileInfo.REGIST_DT);

			fileValue.putTbComFileMapngDetailList(fileDetail);

		}
		setLoadFinish(true);

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	React.useEffect(() => {
		//넘어온 파라미터 바인딩
		if(receivedData !==undefined){
			setDonReqDivCd(StringUtil.defaultString(receivedData.vDON_REQ_DIV_CD));
			setModiSeq(StringUtil.defaultString(receivedData.vMODI_SEQ));
			if(receivedData !==undefined){
				initCall();
			}
		}

	}, [])//effect

	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">기금관리</Link></li>
					<li><Link to="#">출연관리</Link></li>
					<li><Link to="#">출연신청안내관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">출연 신청 안내 상세</h1>

					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={title} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={regUserNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={regDate} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className="ta-view w100p">
										<div className="fund-biz-preview">
											<UISunEditor value={cont} displayOnly />
										</div>
									</div>								
								</div>
							</div>							
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<UI.FileDownloadSimpleMode value={fileValue} viewMode={"simple2"}/>
								</div>
							</div>														
						</div>
					</form>

					<div className="hz-root hz-right hz-gap5 mt10">
						<Button color="gray-o" size="sm" onClick={() => deleteAnn()}>삭제</Button>
						<Button color="gray-o" size="sm" onClick={() => window.history.back()}>목록</Button>
					</div>

				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;